import React, { useState } from 'react';
import { Calendar, ArrowRight, Trash2, Copy, Eye, MoreHorizontal, Layers } from 'lucide-react';


const CreativeCard = ({ creative, previewImage, onDelete, onDuplicate, onPreview, onClick }) => {
  const [imgError, setImgError] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick(creative);
      return;
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
      onDelete(creative.id);
  };

  const handleDuplicate = (e) => {
    e.stopPropagation();
    if (onDuplicate) {
        onDuplicate(creative);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <div
      onClick={handleClick}
      className="group flex flex-col gap-3 cursor-pointer"
    >
      {/* Preview Image Area */}
      <div className="relative aspect-square overflow-hidden rounded-2xl bg-gray-50 border border-gray-100 shadow-sm transition-all duration-300 group-hover:shadow-md">
        {!imgError && (previewImage || creative.preview_url) ? (
          <img
            src={previewImage || creative.preview_url}
            alt={creative.name}
            onError={() => setImgError(true)}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div 
            className="w-full h-full flex flex-col items-center justify-center relative bg-gradient-to-br from-gray-50 to-gray-100 text-gray-300"
          >
            <Layers className="w-12 h-12 mb-2 opacity-50" />
            <span className="text-xs font-medium opacity-50">No Preview</span>
          </div>
        )}
        
        {/* Actions Overlay */}
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center gap-2">
            
            <button 
                onClick={handleDuplicate}
                className="p-2 bg-white rounded-full hover:bg-gray-100 transition-colors"
                title="Duplicate"
            >
                <Copy className="w-4 h-4 text-gray-700" />
            </button>
            <button 
                onClick={handleDelete}
                className="p-2 bg-white rounded-full hover:bg-red-50 transition-colors"
                title="Delete"
            >
                <Trash2 className="w-4 h-4 text-red-500" />
            </button>
        </div>
      </div>
      
      {/* Info Section - Outside the card */}
      <div className="flex flex-col gap-1 px-1">
        <h3 className="text-left text-sm font-semibold text-gray-900 line-clamp-1 group-hover:text-[#8E0DFF] transition-colors duration-200">
            {creative.name}
        </h3>
        
        <div className="flex items-center gap-2 text-xs text-gray-500">
            <span>{formatDate(creative.created_at)}</span>
            {creative.product_count !== undefined && (
                <>
                    <span className="w-1 h-1 rounded-full bg-gray-300" />
                    <span>{creative.product_count} products</span>
                </>
            )}
        </div>
      </div>
    </div>
  );
};

export default CreativeCard;
